import { useTranslation } from "react-i18next";

import { CloseButton, Typography } from "@aviary";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { l } from "@shared/locales/i18n";

import * as styles from "./DesktopFilterHeader.styles";

interface Props {
  onClick: () => void;
}

const DesktopFilterHeader = ({ onClick }: Props) => {
  const { t } = useTranslation();
  const { desktop } = useBreakpoints();
  const isTablet = desktop.lessThan;

  return (
    <div css={styles.wrapper}>
      <Typography type="h4" sizeOverride={isTablet ? "h2" : "h4"} isMarginless>
        {t(l.sharedCommon.Filters)}
      </Typography>
      <CloseButton
        size={isTablet ? "small" : "medium"}
        aria-label={t(l.sharedCommon.CloseFilters)}
        onClick={onClick}
      />
    </div>
  );
};

export { DesktopFilterHeader };
